import { apiClient } from '@/shared/api';

import type { BudgetRequest, BudgetResponse } from '../model/types';

/**
 * Budgets live at the catalog-level `/api/v1/catalog/budgets` — NOT under `/promo/` like every
 * other promo resource (verified against the shipped `openapi.yml`; this is the one path that
 * breaks the `/catalog/promo/*` pattern the rest of this feature follows).
 *
 * Contract gap (resolved, not guessed): the BFF exposes only create / get-by-id / get-burn for
 * budgets — there is no `list budgets` endpoint, and `PromotionResponse` carries no back-reference
 * to "its" budget (only `CampaignResponse.budgetId` exists). A PROMOTION-scoped budget is
 * therefore only reachable by an id the caller already holds (e.g. right after creating it in the
 * same session) — see `BudgetsPanel`'s comment for how it copes with this by discovering
 * CAMPAIGN-scoped budgets via the campaigns list and keeping session-created budgets visible.
 */
const BASE = '/api/v1/catalog/budgets';

export const createBudget = async (body: BudgetRequest): Promise<BudgetResponse> =>
  (await apiClient.post<BudgetResponse>(BASE, body)).data;

export const getBudget = async (budgetId: string): Promise<BudgetResponse> =>
  (await apiClient.get<BudgetResponse>(`${BASE}/${budgetId}`)).data;

export const getBudgetBurn = async (budgetId: string): Promise<BudgetResponse> =>
  (await apiClient.get<BudgetResponse>(`${BASE}/${budgetId}/burn`)).data;
